<main class="container">
    <h1 class="title">{{"Messaging" | translate}}</h1>
    <mat-divider class="divider"></mat-divider>
    <div class="chat-container">
        <app-chat-box class="chat-box"></app-chat-box>
    </div>
    
</main>
